import {
    useQuery
  } from '@tanstack/react-query'

// Throttle global do browser: serializa os pedidos ao Nominatim com >=1100ms entre cada, para
// respeitar o limite de 1 req/seg POR IP. Geocodifica-se no CLIENTE (cada browser tem o seu IP =
// o seu orçamento de 1/seg) em vez de concentrar tudo no IP do servidor (que fica logo bloqueado).
// Isto mata o 429 das rajadas (N cards a disparar em paralelo) sem criar um gargalo central.
let lastNominatimCallMs = 0;
let nominatimQueue: Promise<unknown> = Promise.resolve();

const throttledReverse = (lat: number, long: number): Promise<any> => {
    const run = nominatimQueue.then(async () => {
        const wait = 1100 - (Date.now() - lastNominatimCallMs);
        if (wait > 0) await new Promise(resolve => setTimeout(resolve, wait));
        lastNominatimCallMs = Date.now();
        const res = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${long}&format=json&addressdetails=1`);
        return res.json();
    });
    // Manter a fila a andar mesmo que um pedido falhe.
    nominatimQueue = run.then(() => undefined, () => undefined);
    return run;
};

export const useGeoLocator = (lat: number, long: number, _lang: string | null = null, enabled = true) => {
    return useQuery({
        queryKey: ['geolocator', `${lat},${long}`],
        queryFn: () => throttledReverse(lat, long),
        retryDelay: 2000,
        retry: 1,
        enabled
    });
};


export const addressFormat = (data: any,latitude:number,longitude:number) => {
    if (data?.display_name) { // OSM
        const address = data?.address;
        if (address.country_code === 'fr') {
            const list = [];
            if (address.house_number) {
                list.push(address.house_number);
            }
            if (address.road) {
                list.push(address.road);
            }
            if (address.postcode) {
                list.push(address.postcode);
            }
            if (address.town) {
                list.push(address.town);
            }
            if (address.municipality) {
                list.push(address.municipality);
            }
            if (address.country) {
                list.push(address.country);
            }
            return list.join(', ');
        } else {
            return data?.display_name
        }
    }
    return (data && data.results && data.results.length > 0 ? data.results[0].formatted_address :  `${latitude},${longitude}`);
};
